// extracted by mini-css-extract-plugin
export default {"dialogos1":"Saludos_dialogos1__AwFbz","dialogos2":"Saludos_dialogos2__XNBM2","dialogos3":"Saludos_dialogos3__fsnax"};